import React, { memo } from 'react'
import { Dialog, Typography } from '@material-ui/core'
import clsx from 'clsx'
import useOrderStyle from './Order.style'
import Button from '../Button/Button'
import ErrorIcon from '@material-ui/icons/Error'
import CloseIcon from '@material-ui/icons/Close'
import CMSText from '../Global/CMSText'
import { useTranslation } from 'react-i18next'
import {
  OpenModalCancelOrderList,
  OrderInformations,
} from '../../typings/orders'
import { useThrottle } from '../../hooks/useThrottle'

type Tprops = {
  prismicAccountData: any
  openModal: OpenModalCancelOrderList
  handleClose: () => void
  handleCancel: (order: OrderInformations) => void
  order: any
}

const ModalCancelOrder = memo(
  ({
    order,
    openModal,
    handleClose,
    prismicAccountData,
    handleCancel,
  }: Tprops) => {
    const { t } = useTranslation()
    const classes = useOrderStyle()

    const onCancelOrder = useThrottle(handleCancel, 500)

    return (
      <Dialog
        className={clsx('modal-cancelOrder', classes.modal)}
        open={openModal.currentOrder === order.orderNumber}
        onClose={handleClose}
        maxWidth={'md'}
        disableBackdropClick
      >
        <div className={clsx('modal-cancelOrder__head', classes.modalHead)}>
          <Typography variant="body1" component={'h2'}>
            <span
              className={clsx(
                'modal-cancelOrder__warning',
                classes.modalHeadWarning
              )}
            >
              <ErrorIcon />
              <span>
                <CMSText
                  asText
                  data={prismicAccountData?.cancel_order_modal_title}
                  defaultText={t('texts:account:cancel_order:modal_title')}
                />
              </span>
            </span>
          </Typography>
          <CloseIcon
            className={clsx('modal-cancelOrder__close', classes.modalClose)}
            onClick={handleClose}
          />
        </div>
        <div
          className={clsx('modal-cancelOrder__content', classes.modalContent)}
        >
          <Typography variant={'h4'} component={'h3'}>
            <CMSText
              asText
              data={prismicAccountData?.command}
              defaultText={t('texts:account:command')}
            />
            {order.orderNumber || order.number}
          </Typography>
          <Typography component={'div'}>
            <CMSText
              asText
              data={prismicAccountData?.cancel_order_modal_warn}
              defaultText={t('texts:account:cancel_order:modal_warn')}
            />
          </Typography>
          <Button
            color={'primary'}
            variant={'outlined'}
            size={'small'}
            className={clsx('modal-cancelOrder__cta', classes.cancelCTA)}
            onClick={() => onCancelOrder(order)}
          >
            <CMSText
              asText
              data={prismicAccountData?.cancel_order_modal_cta}
              defaultText={t('texts:account:cancel_order:modal_cta')}
            />
          </Button>
        </div>
      </Dialog>
    )
  }
)

export default ModalCancelOrder
